export const moonRabbitContractAddress = '0xb3Ba1D4E935F0d917E1eC7d19Ca657e29F4Ada5A';
export const moonRabbitChainId = '0x500';
// export const moonRabbitChainId = 0x4;
// export const chainName = 'Rinkeby';
export const chainName = 'Moon Rabbit';
export const marketplaceUrl = 'https://hashlab.online';
